import React from "react";

import Navbar from '../components/Navbar'
import Grid from '../components/Grid'



const ProjectsPage = () => {

  return (
    <div>
      <Navbar />
      <Grid />
    </div>
  );
}

export default ProjectsPage;